import * as React from 'react';
import clsx from 'clsx';

interface Props {
  align?: 'center' | 'left' | 'right' | 'spaceBetween';
  children?: React.ReactNode;
  className?: string;
  inline?: boolean;
  type?: 'bar' | 'floating' | 'stretch';
  role?: string;
  'aria-label'?: string;
}

const alignMapping: { [index: string]: string } = {
  center: 'ButtonGroup--centerAligned',
  left: 'ButtonGroup--leftAligned',
  right: 'ButtonGroup--rightAligned',
  spaceBetween: 'ButtonGroup--spaceBetween',
};

const typeMapping: { [index: string]: string } = {
  // Bar = Visually connected buttons with rounded corners on the first and last
  bar: 'ButtonGroup--bar',
  // Floating = Buttons are separated by a margin, all have rounded corners
  floating: 'ButtonGroup--floating',
  // buttons within the group fill the space with margins between
  stretch: 'ButtonGroup--stretch',
};

export default class ButtonGroup extends React.PureComponent<Props> {
  static defaultProps: Partial<Props> = {
    align: 'center',
    inline: false,
    type: 'floating',
  };

  render() {
    const {
      align,
      className: classNameFromProps,
      children,
      inline,
      type,
      role,
      'aria-label': ariaLabel,
    } = this.props;

    const alignClassName = alignMapping[align as string];
    const typeClassName = typeMapping[type as string];
    const className = clsx('ButtonGroup', alignClassName, typeClassName, classNameFromProps, {
      'ButtonGroup--is-inline': inline,
    });

    return (
      <div className={className} role={role} aria-label={ariaLabel}>
        {children}
      </div>
    );
  }
}
